import { gql } from '@apollo/client';
const PARTNER_SEARCHES_WITH_VALIDATIONS = gql`
  query userPartnerSearches($page: Int, $limit: Int, $filter: ListPartnerSearchInput, $email: String) {
    userPartnerSearches(page: $page, limit: $limit, filter: $filter, email: $email) 
  }
`;
export default PARTNER_SEARCHES_WITH_VALIDATIONS;
